const removeEmptyLines = (str: string) => str.replace(/[\s\r\n]+$/, '');

export default removeEmptyLines;
